/**
 * MissionControlPulse.tsx
 *
 * Left panel of the Mission Control layout.
 * Contains: Time Machine Clock, Step Progress, and Live Stats.
 */

import React from 'react';
import { ProgressStep, LiveStats } from '../../types/backtest';
import TimeMachineClock from './TimeMachineClock';
import BacktestStepProgress from './BacktestStepProgress';
import LiveStatsPanel from './LiveStatsPanel';

interface MissionControlPulseProps {
  steps: ProgressStep[];
  currentMessage: string;
  liveStats: LiveStats;
}

const MissionControlPulse: React.FC<MissionControlPulseProps> = ({
  steps,
  currentMessage,
  liveStats
}) => {
  return (
    <div className="bt-pulse">
      {/* Time Machine Clock */}
      <TimeMachineClock currentDate={liveStats.currentDate} />

      {/* Step Progress with Events/Sec */}
      <BacktestStepProgress
        steps={steps}
        currentMessage={currentMessage}
        eventsPerSecond={liveStats.eventsPerSecond}
      />

      {/* Live Statistics */}
      <LiveStatsPanel
        tradesCount={liveStats.tradesCount}
        winsCount={liveStats.winsCount}
        winRate={liveStats.winRate}
        pnlRunning={liveStats.pnlRunning}
      />
    </div>
  );
};

export default MissionControlPulse;
